import { render } from "./LoadingCircle.vue?vue&type=template&id=308a232e"
import script from "./LoadingCircle.vue?vue&type=script&lang=js"
export * from "./LoadingCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__